import moment from "moment";

export const sortBy = (items: string[], value: "ASC" | "DESC"): string[] => {
  return items.sort((a, b) => {
    if (value === "ASC") return moment(a).valueOf() - moment(b).valueOf();
    return moment(b).valueOf() - moment(a).valueOf();
  });
};

export const toDayMonthDateFormat = (date?: moment.Moment) => {
  return toDateFormat(date, "ddd, MMM Do");
};

export const toDateFormat = (date: moment.Moment | string | undefined, format: string) => {
  return date && moment(date).format(format);
};

export const forEachDay = (start: moment.Moment, end: moment.Moment, callbackFn: (day: moment.Moment) => void) => {
  for (var day = moment(start); day.isBefore(end); day.add(1, "days")) {
    callbackFn(day);
  }
};

export const findDay = (
  start: moment.Moment,
  end: moment.Moment,
  predicate: (day: moment.Moment) => boolean,
  inclusive: boolean = true
): moment.Moment | null => {
  for (var day = moment(start); inclusive ? day.diff(end, "days") <= 0 : day.isBefore(end); day.add(1, "days")) {
    if (predicate(day)) return day;
  }
  return null;
};
